import React, { memo } from 'react'
import Page from 'components/layout/Page'
import usePageProps from 'hooks/usePageProps'
import PostCard from 'components/BlogPage/PostCard'
import Container from '@mui/material/Container'
import Grid from '@mui/material/Grid2'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { FormattedMessage, useIntl } from 'react-intl'
import Pagination from '@mui/material/Pagination'
import { useRouter } from 'next/router'
import SearchBar from 'components/BlogPage/SearchBar'
import Text, { TEXT_TYPES } from 'components/designSystem/Text'
import MainBanner from 'components/shared/MainBanner'
import BannerImage from 'public/img/blog/foto-blog.png'
import { useMediaQuery } from '@mui/material'
import sx from './styles'

const Blog = () => {
  const { formatMessage: f } = useIntl()
  const router = useRouter()
  const {
    posts, totalPages, page, search, titleMeta, descriptionMeta,
  } = usePageProps()
  const mostRecents = posts.slice(0, 4)
  const allPosts = posts.slice(4, posts.length)
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('sm'))
  const mainBanner = {
    title: !isMobile && f({ id: titleMeta }),
    subtitle: !isMobile && f({ id: descriptionMeta }),
    mainImage: {
      url: BannerImage,
      alt: f({ id: titleMeta }),
    },
  }

  const onChangePage = (e, value) => {
    if (value === page) return
    let url = `/blog?page=${value}`
    if (search.length > 0) url = `${url}&search=${search.trim()}`
    router.push(url, null, { scroll: false }).then(() => window.scrollTo({
      behavior: 'smooth',
      top: 0,
    }))
  }

  const onSearch = (textSearch) => {
    router.push(`/blog?search=${textSearch.trim()}`, null, { scroll: false })
  }

  const searcBar = (
    <SearchBar
      onClick={(value) => onSearch(value)}
      search={search}
    />
  )
  const postsLength = posts.length > 0

  return (
    <Page>
      <Container
        maxWidth="lg"
      >
        <Box sx={sx.banner}>
          {isMobile && (
            <Box
              py={2}
              pb={0}
            >
              <Typography
                variant="h1"
                mb={2}
                mt={8}
              >
                {f({ id: titleMeta })}
              </Typography>
              <Typography
                variant="h2"
                mb={2}
              >
                {f({ id: descriptionMeta })}
              </Typography>
              {searcBar}
            </Box>
          )}
          <MainBanner
            sx={{ px: '0 !important' }}
            {...mainBanner}
          >
            {!isMobile && searcBar}
          </MainBanner>
        </Box>
        <Grid
          container
          spacing={2}
          sx={sx.containerHead}
        >
          <Text
            type={TEXT_TYPES.heading.h2}
            mb={2}
            px={isMobile ? 1.5 : 0}
          >
            {postsLength && <FormattedMessage id="BLOG_MAIN_TITLE" />}
          </Text>
        </Grid>
        <Grid
          container
          spacing={2}
          sx={{ ...sx.container, ...sx.conatainerFirst }}
        >
          {mostRecents.map((item, i) => (
            <Grid
              key={`recents-${i}`}
              size={{
                xs: 11,
                sm: i === 0 ? 12 : 6,
                md: i === 0 ? 12 : 'auto',
              }}
              sx={sx.itemContainer}
            >
              <PostCard
                key={`post-card-${i}`}
                post={item}
                variant={
                  i === 0 ? (isMobile ? 'vertical' : 'horizontal') : 'vertical'
                }
                tagTopText={i === 0 ? 'Más reciente' : 'Más visitado'}
                sxProps={sx.mostRecent}
                variantTitle="h3"
              />
            </Grid>
          ))}
        </Grid>
        {allPosts.length > 0 && (
          <Text
            type={TEXT_TYPES.heading.h2}
            mb={2}
            px={isMobile ? 1.5 : 0}
          >
            <FormattedMessage id="BLOG_SECONDARY_TITLE" />
          </Text>
        )}
        <Grid
          container
          spacing={2}
          sx={sx.container}
        >
          {allPosts.map((item, i) => (
            <Grid
              key={`post-${i}`}
              size={{
                xs: 11,
                sm: 6,
                md: 'auto',
              }}
              sx={sx.itemContainer}
            >
              <PostCard
                key={`post-card-${i}`}
                post={item}
                sxProps={sx.otherNotes}
                variantTitle="h4"
              />
            </Grid>
          ))}
          {!postsLength && (
            <Typography
              variant="p"
              gutterBottom
            >
              <FormattedMessage id="BLOG_NONE_POSTS" />
            </Typography>
          )}
        </Grid>
        {postsLength && (
          <Grid
            container
            spacing={2}
            sx={sx.containerPaginator}
          >
            <Pagination
              count={totalPages}
              onChange={onChangePage}
              page={page}
              sx={sx.pagination}
            />
          </Grid>
        )}
      </Container>
    </Page>
  )
}

export default memo(Blog)
